module.exports = __webpack_public_path__ + "img/cash_nl25.05b7ea45.png";